import request from "../request";
import sysrequest from "../sysrequest";

const api = {
  search_bidmain(data) {
    const obj = {
      url: "/bid/demo_v1/bid_main/search_bidmain/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },
};

export default api;
